// extracted by mini-css-extract-plugin
export default {"primary":"faq_primary__7+y+A","vl_line":"faq_vl_line__I03XE","text_container":"faq_text_container__4+RQQ","text_filling":"faq_text_filling__OsDGT"};